"use client";

import React from "react";
import { Link as ZapierLink, Text } from "@zapier/design-system";
import { ReactMarkdown } from "react-markdown/lib/react-markdown";
import dedent from "dedent";
import rehypeRaw from "rehype-raw";
import styles from "./Markdown.module.css";
import classNames from "classnames";

interface MarkdownProps {
  content: string;
}

interface MarkdownComponentProps {
  children: React.ReactNode;
}

interface MarkdownLinkProps extends MarkdownComponentProps {
  href?: string;
}

const H1 = ({ children }: MarkdownComponentProps) => (
  <div className={styles.headerOne}>
    <Text type="PageHeader" tag="h1">
      {children}
    </Text>
  </div>
);

const H2 = ({ children }: MarkdownComponentProps) => (
  <div className={styles.headerTwo}>
    <Text type="SectionHeader" tag="h2">
      {children}
    </Text>
  </div>
);

const H3 = ({ children }: MarkdownComponentProps) => (
  <div className={styles.headerThree}>
    <Text type="ParagraphHeader1" tag="h3">
      {children}
    </Text>
  </div>
);

const P = ({ children }: MarkdownComponentProps) => (
  <div className={styles.paragraph}>
    <Text type="Body1" tag="p">
      {children}
    </Text>
  </div>
);

const Link = ({ children, href }: MarkdownLinkProps) => (
  <ZapierLink href={href ?? "#"}>{children}</ZapierLink>
);

const UL = ({ children }: MarkdownComponentProps) => (
  <Text type="Body1">
    <ul className={classNames([styles.list, styles.unorderedList])}>
      {children}
    </ul>
  </Text>
);

const OL = ({ children }: MarkdownComponentProps) => (
  <Text type="Body1">
    <ul className={classNames([styles.list, styles.orderedList])}>
      {children}
    </ul>
  </Text>
);

export const Markdown = ({ content }: MarkdownProps) => (
  <ReactMarkdown
    className={styles.markdownWrapper}
    // @ts-ignore the types don't seem to match up
    rehypePlugins={[rehypeRaw]}
    skipHtml={false}
    components={{
      h1: H1,
      h2: H2,
      h3: H3,
      p: P,
      a: Link,
      ul: UL,
      ol: OL,
    }}
  >
    {dedent(content)}
  </ReactMarkdown>
);
